import { DBConfig } from "ngx-indexed-db";
import { tokenStoreConfig } from "./stores/tokens";


export const dbConfig: DBConfig  = {
  name: 'oskarudb',
  version: 1,
  objectStoresMeta: [{
    store: tokenStoreConfig.name,
    storeConfig: { keyPath: 'id', autoIncrement: false },
    storeSchema: [
      {
        name: tokenStoreConfig.columns.tokenType,
        keypath: tokenStoreConfig.columns.tokenType,
        options: { unique: true }
      },
      {
        name: tokenStoreConfig.columns.token,
        keypath: tokenStoreConfig.columns.token,
        options: { unique: true }
      }
    ]
  }],
  migrationFactory
}

function migrationFactory() {
  return {
    /*1: (db: any, transaction: { objectStore: (arg0: string) => any; }) => {
      const store = transaction.objectStore('people');
      store.createIndex('country', 'country', {unique: false});
    },
    3: (db: any, transaction: { objectStore: (arg0: string) => any; }) => {
      const store = transaction.objectStore('people');
      store.createIndex('age', 'age', {unique: false});
    }*/
  };
}
